import React, { FC, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import '@wix/design-system/styles.global.css';
import { useFedopsLogger } from '../../contexts/FedopsLoggerContext';
import { appRoutes } from '../../routes';
import TemplatesPage from '../TemplatesPage/TemplatesPage';
import { BiLoggerProvider } from '../../contexts/BILoggerContext';
import { PreviewTemplateContextProvider } from '../../contexts/PreviewTemplateContext';

import { TemplatesProvider } from '../../contexts/TemplatesContext';
import './App.scss';
import { HtmlHead } from '../HtmlHead/HtmlHead';
import { PageScrollContextProvider } from '../../contexts/PageScrollContext';

const App: FC = () => {
  const fedopsLogger = useFedopsLogger();

  useEffect(() => {
    fedopsLogger.reportAppLoaded();
  }, []);

  return (
    <Routes>
      <Route
        path={appRoutes.category.pattern}
        element={
          <PageScrollContextProvider>
            <BiLoggerProvider>
              <TemplatesProvider>
                <PreviewTemplateContextProvider>
                  <HtmlHead />
                  <TemplatesPage />
                </PreviewTemplateContextProvider>
              </TemplatesProvider>
            </BiLoggerProvider>
          </PageScrollContextProvider>
        }
      />
    </Routes>
  );
};

export default App;
